export default __webpack_public_path__ + "static/media/loading.10625dac.gif";